<template lang="pug">
v-container(fluid='')
      v-card
        v-card-title.d-flex.justify-space-between
          span Solicitudes de Presupuesto
          v-btn(color='primary', @click='openDialog()')
            v-icon(left='') mdi-plus
            |  Nueva Solicitud
        v-card-text
          v-data-table(:headers='headers', :items='requests', :loading='loading')
            template(v-slot:item.category='{ item }')
              v-chip(small='') {{ getCategoryLabel(item.category) }}
            template(v-slot:item.createdAt='{ item }')
              | {{ formatDate(item.createdAt) }}
            template(v-slot:item.priority='{ item }')
              v-chip(small='', :color='getPriorityColor(item.priority)')
                | {{ getPriorityLabel(item.priority) }}
            template(v-slot:item.status='{ item }')
              v-chip(small='', :color='getStatusColor(item.status)')
                | {{ getStatusLabel(item.status) }}
            template(v-slot:item.actions='{ item }')
                v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                  v-icon mdi-eye
                v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                  v-icon mdi-pencil
                v-btn(v-if="canReviewRequests && item.status === 'pending'", icon='', small='', @click='openReviewDialog(item)')
                  v-icon mdi-check-circle
      // Request Dialog
      v-dialog(v-model='dialog', max-width='800')
        v-card
          v-card-title
            | {{ editedItem._id ? editedItem.title : &apos;Nueva Solicitud de Presupuesto&apos; }}
          v-card-text
            v-form(ref='form', v-model='valid')
              v-text-field(v-model='editedItem.title', label='Título', :rules="[v => !!v || 'El título es requerido']", required='')
              v-textarea(v-model='editedItem.description', label='Descripción', :rules="[v => !!v || 'La descripción es requerida']", required='')
              v-row
                v-col(cols='12', sm='6')
                  v-select(v-model='editedItem.category', :items='categories', label='Categoría', :rules="[v => !!v || 'La categoría es requerida']", required='')
                v-col(cols='12', sm='6')
                  v-select(v-model='editedItem.priority', :items='priorities', label='Prioridad', :rules="[v => !!v || 'La prioridad es requerida']", required='')
              // Budgets Section
              v-card.mb-4(v-for='(budget, index) in editedItem.budgets', :key='index', outlined='')
                v-card-title.subtitle-1
                  | Presupuesto {{ index + 1 }}
                  v-spacer
                  v-btn(icon='', small='', color='error', @click='removeBudget(index)', v-if='editedItem.budgets.length > 2')
                    v-icon mdi-delete
                v-card-text
                  v-row
                    v-col(cols='12', sm='6')
                      v-text-field(v-model='budget.provider.name', label='Nombre del Proveedor', :rules="[v => !!v || 'El nombre es requerido']", required='')
                    v-col(cols='12', sm='6')
                      v-text-field(v-model.number='budget.amount', label='Monto', type='number', prefix='$', :rules="[v => !!v || 'El monto es requerido']", required='')
                    v-col(cols='12', sm='6')
                      v-text-field(v-model='budget.provider.phone', label='Teléfono')
                    v-col(cols='12', sm='6')
                      v-text-field(v-model='budget.provider.email', label='Email', type='email')
                    v-col(cols='12')
                      v-file-input(
                        v-model='budget.file'
                        name='budgets'
                        label='Adjuntar Presupuesto'
                        accept='.pdf,.doc,.docx,.jpg,.jpeg,.png'
                        :rules="[v => !!v || 'El archivo es requerido']"
                        required=''
                        show-size=''
                        prepend-icon='mdi-file-document'
                      )
                      v-btn.mt-2(
                        v-if='budget.fileUrl'
                        text
                        color='primary'
                        @click='previewBudget(budget)'
                      )
                        v-icon(left) mdi-eye
                        | Ver presupuesto
                    v-col(cols='12')
                      v-textarea(v-model='budget.observations', label='Observaciones', rows='2')
              v-btn(v-if='editedItem.budgets.length < 3', color='primary', text='', @click='addBudget')
                v-icon(left='') mdi-plus
                |  Agregar Presupuesto
          v-card-actions
            v-spacer
            v-btn(text='', @click='closeDialog')  Cancelar
            v-btn(color='primary', :disabled='!isValid', :loading='saving', @click='save')  Guardar
      // Review Dialog
      v-dialog(v-model='reviewDialog', max-width='500')
        v-card
          v-card-title Revisar Solicitud
          v-card-text
            v-form(ref='reviewForm', v-model='reviewValid')
              v-select(v-model='review.status', :items='statusOptions', label='Estado', :rules="[v => !!v || 'Selecciona un estado']", required='')
              v-textarea(v-model='review.notes', label='Notas de revisión', :rules="[v => !!v || 'Las notas son requeridas']", required='', rows='3')
          v-card-actions
            v-spacer
            v-btn(text='', @click='reviewDialog = false')  Cancelar
            v-btn(color='primary', :disabled='!reviewValid', @click='submitReview')  Confirmar
      // Budget Preview Dialog
      v-dialog(v-model='previewDialog', max-width='90vw', max-height='90vh')
        v-card
          v-card-title.primary.white--text
            | Presupuesto
            v-spacer
            v-btn(icon='', @click='previewDialog = false', dark)
              v-icon mdi-close
          v-card-text.pa-0
            v-container.pa-0(fluid)
              v-row(no-gutters)
                v-col(cols='12')
                  iframe(
                    :src='selectedBudgetUrl'
                    style='width: 100%; height: 80vh; border: none;'
                  )
          v-card-actions
            v-spacer
            v-btn(color='primary', text, :href='selectedBudgetUrl', target='_blank')
              v-icon(left) mdi-download
              | Descargar
            v-btn(text, @click='previewDialog = false') Cerrar
</template>
<script>
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

export default {
  name: 'BudgetRequestsView',
  data: () => ({
    loading: false,
    dialog: false,
    reviewDialog: false,
    previewDialog: false,
    valid: false,
    reviewValid: false,
    saving: false,
    headers: [
      { text: 'Título', value: 'title' },
      { text: 'Categoría', value: 'category' },
      { text: 'Prioridad', value: 'priority' },
      { text: 'Estado', value: 'status' },
      { text: 'Solicitado por', value: 'requestedBy.name' },
      { text: 'Fecha', value: 'createdAt' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedItem: {
      title: '',
      description: '',
      category: '',
      priority: '',
      budgets: [{
        provider: {
          name: '',
          phone: '',
          email: ''
        },
        amount: 0,
        observations: '',
        file: null
      }, {
        provider: {
          name: '',
          phone: '',
          email: ''
        },
        amount: 0,
        observations: '',
        file: null
      }]
    },
    review: {
      status: '',
      notes: ''
    },
    selectedRequest: null,
    categories: [
      { text: 'Reparación', value: 'repair' },
      { text: 'Compra', value: 'purchase' },
      { text: 'Mejora', value: 'improvement' }
    ],
    priorities: [
      { text: 'Baja', value: 'low' },
      { text: 'Media', value: 'medium' },
      { text: 'Alta', value: 'high' },
      { text: 'Urgente', value: 'urgent' }
    ],
    statusOptions: [
      { text: 'Aprobado', value: 'approved' },
      { text: 'Rechazado', value: 'rejected' },
      { text: 'En revisión', value: 'review' }
    ],
    selectedBudgetUrl: null
  }),

  computed: {
    requests() {
      return this.$store.state.budgetRequests.list
    },
    canReviewRequests() {
      return this.$store.getters['auth/hasPermission']('approve_budgets')
    },
    isValid() {
      return this.valid && this.editedItem.budgets.length >= 2
    }
  },

  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: es })
    },
    getEmptyBudget() {
      return {
        provider: {
          name: '',
          phone: '',
          email: ''
        },
        amount: 0,
        observations: '',
        file: null
      }
    },

    getCategoryLabel(category) {
      const found = this.categories.find(c => c.value === category)
      return found ? found.text : category
    },

    getPriorityLabel(priority) {
      const found = this.priorities.find(p => p.value === priority)
      return found ? found.text : priority
    },

    getPriorityColor(priority) {
      const colors = {
        low: 'success',
        medium: 'warning',
        high: 'orange',
        urgent: 'error'
      }
      return colors[priority] || 'grey'
    },

    getStatusLabel(status) {
      return {
        pending: 'Pendiente',
        approved: 'Aprobado',
        rejected: 'Rechazado',
        review: 'En revisión'
      }[status] || status
    },

    getStatusColor(status) {
      return {
        pending: 'warning',
        approved: 'success',
        rejected: 'error',
        review: 'info'
      }[status] || 'grey'
    },

    openDialog(item = null) {
      this.editedItem = item
        ? { ...item }
        : {
            title: '',
            description: '',
            category: '',
            priority: '',
            budgets: [{
              provider: {
                name: '',
                phone: '',
                email: ''
              },
              amount: 0,
              observations: '',
              file: null
            }, {
              provider: {
                name: '',
                phone: '',
                email: ''
              },
              amount: 0,
              observations: '',
              file: null
            }]
          }
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.$refs.form.reset()
      })
    },

    addBudget() {
      if (this.editedItem.budgets.length < 3) {
        this.editedItem.budgets.push(this.getEmptyBudget())
      }
    },

    removeBudget(index) {
      if (this.editedItem.budgets.length > 2) {
        this.editedItem.budgets.splice(index, 1)
      }
    },

    openReviewDialog(request) {
      this.selectedRequest = request
      this.review = {
        status: '',
        notes: ''
      }
      this.reviewDialog = true
    },

    async submitReview() {
      if (!this.$refs.reviewForm.validate()) return

      try {
        await this.$store.dispatch('budgetRequests/review', {
          requestId: this.selectedRequest._id,
          ...this.review
        })
        this.$toast.success('Solicitud revisada')
        this.reviewDialog = false
      } catch (error) {
        this.$toast.error('Error al revisar la solicitud')
      }
    },

    async save() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      try {
        const formData = new FormData()
        // Add basic request data
        formData.append('title', this.editedItem.title)
        formData.append('description', this.editedItem.description)
        formData.append('category', this.editedItem.category)
        formData.append('priority', this.editedItem.priority)

        // Add budget files
        this.editedItem.budgets.forEach((budget, index) => {
          if (budget.file) {
            formData.append('files', budget.file)
          }
        })

        // Add budget data as JSON
        formData.append('budgets', JSON.stringify(
          this.editedItem.budgets.map(budget => ({
            provider: {
              name: budget.provider.name,
              phone: budget.provider.phone,
              email: budget.provider.email
            },
            amount: budget.amount,
            observations: budget.observations
          }))
        ))

        if (this.editedItem._id) {
          await this.$store.dispatch('budgetRequests/update', {
            id: this.editedItem._id,
            data: formData
          })
          this.$toast.success('Solicitud actualizada')
        } else {
          await this.$store.dispatch('budgetRequests/create', formData)
          this.$toast.success('Solicitud creada')
        }
        this.closeDialog()
      } catch (error) {
        this.$toast.error('Error al guardar la solicitud')
      } finally {
        this.saving = false
      }
    },
    previewBudget(budget) {
      this.selectedBudgetUrl = budget.fileUrl;
      this.previewDialog = true;
    }
  },

  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('budgetRequests/fetch')
    } catch (error) {
      this.$toast.error('Error al cargar las solicitudes')
    } finally {
      this.loading = false
    }
  }
}
</script>
